<h6 class="details" [ngStyle]="{'width': expandWidth}" *ngIf="!showRules">
    <span class="ml-3 mr-3 montserrat" (click)="setShowRules(true)">
        <i class="fal fa-angle-down mr-2" aria-hidden="true"></i>
        {{'ASSESSMENT-SHOW-RULES' | translate}}
    </span>
</h6>
<h6 class="details" [ngStyle]="{'width': expandWidth}" *ngIf="showRules">
    <span class="ml-3 mr-3 montserrat" (click)="setShowRules(false)">
        <i class="fal fa-angle-up mr-2" aria-hidden="true"></i>
        {{'ASSESSMENT-HIDE-RULES' | translate}}
    </span>
</h6>
<div class="rules-width mt-1" *ngIf="showRules">
    <app-query-builder *ngIf="queryConfig" [data]="query" [config]="queryConfig" [classNames]='classNames'
        [disabled]="isDeleted || isLocked">
    </app-query-builder>
</div>